'use client'

import { useEffect, useState } from 'react'

// ============================================================================
// useMounted — «мы уже в браузере?»
// ============================================================================
// Зачем нужен. Сервер и клиент ОБЯЗАНЫ отрисовать первый кадр одинаково —
// иначе React падает с ошибкой гидратации (#418: «text content does not match»).
//
// А время у них разное:
//   сервер  живёт в UTC        → «3 дня назад»
//   браузер живёт в Кишинёве   → «2 дня назад»
//
// Тексты расходятся — и приложение сыпется в консоль на каждой странице.
//
// Правило: всё, что зависит от «сейчас» (относительное время, «Сегодня»,
// «Вчера», просрочено/нет), рисуется ТОЛЬКО после монтирования. До этого
// показываем детерминированный вариант — обычную дату, одинаковую везде.
//
//   const mounted = useMounted()
//   return <span>{mounted ? timeAgo(date) : formatDateFixed(date)}</span>
// ============================================================================
export function useMounted(): boolean {
  const [mounted, setMounted] = useState(false)
  useEffect(() => setMounted(true), [])
  return mounted
}
